import { Button, DatePicker, Form } from "antd";
import axios from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { authenticateToken } from "../../utils/auth";
import { getPage, getParamValue } from "../../utils/index";
import Loading from "../common/Loader";
import PaginationTwo from "../common/PaginationTwo";
import TopHeading from "./TopHeading";
import { debounce } from "lodash";
import Empty from "../common/Empty";
import moment from "moment";

const { RangePicker } = DatePicker;

const UserTransactionList = () => {
  const [mobileNumber, setMobileNumber] = useState("");
  const [limit, setLimit] = useState(16);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(undefined);
  const [transactionData, setTransactionData] = useState({
    loading: false,
    data: null,
  });

  const [range, setRange] = useState({
    from: null,
    to: null,
  });
  const from = moment(range.from)?.toISOString();
  const to = moment(range.to)?.toISOString();

  const fetchRef = useRef(null);

  const [form] = Form.useForm();
  const loc = useLocation();
  const page = getParamValue(loc.search, "page");

  const getTransactions = useCallback(async () => {
    setTransactionData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_RIDER_API}`;
    axios
      .get(
        `${encodedUri}/admin/transaction/history` +
          // (mobileNumber
          //   ? `&mobile=%2B88${mobileNumber?.replace("+88", "")}`
          //   : ``) +
          `?page=${page || 0}` +
          `&limit=${limit || 16}` +
          (from ? `&from=${from}` : ``) +
          (to ? `&to=${to}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      )
      .then((res) => {
        setTransactionData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setTransactionData({ loading: false, data: [] });
        console.error("Drivers: Error", err);
      });
  }, [range.from, range.to, page, limit]);

  // const getTransactionsOptions = useCallback(
  //   async (mobileNumber) => {
  //     setDriversOptions({ loading: true, list: null });
  //     const encodedUri = `${process.env.REACT_APP_RIDER_API}`;
  //     axios
  //       .get(
  //         `${encodedUri}/admin/transaction?` +
  //           (mobileNumber
  //             ? `&mobile=%2B88${mobileNumber?.replace("+88", "")}`
  //             : ``) +
  //           (status ? `&status=${status}` : ``) +
  //           `&page=${0}` +
  //           `&limit=${20}`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${authenticateToken()}`,
  //           },
  //         }
  //       )
  //       .then((res) => {
  //         setDriversOptions({
  //           loading: false,
  //           list: res.data?.drivers?.map((transaction) => ({
  //             label: transaction.name,
  //             value: transaction.mobileNumber,
  //           })),
  //         });
  //       })
  //       .catch((err) => {
  //         setDriversOptions({ loading: false, list: [] });
  //         console.error("Drivers: Error", err);
  //       });
  //   },
  //   [status]
  // );

  useEffect(() => {
    getTransactions();
  }, [getTransactions]);

  const getTransactionsOptionsDebounce = React.useMemo(() => {
    const loadOptions = (value: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }

      // getDriversOptions(value);
    };

    return debounce(loadOptions, 800);
  }, []);

  const reseAllFieldData = () => {
    setMobileNumber("");
    form.resetFields();
  };

  return (
    <React.Fragment>
      <TopHeading
        total={transactionData?.data?.totalElements}
        refetch={getTransactions}
      />
      <section className="search_area">
        <Form form={form} className="search_form">
          {/* <Form.Item name="search">
            <AutoComplete
              style={{ width: 300 }}
              // onSearch={getDriversOptionsDebounce}
              onSelect={(val) => setMobileNumber(val)}
              options={driversOptions?.list}
              defaultActiveFirstOption={false}
              notFoundContent={
                driversOptions?.loading ? <Spin size="small" /> : null
              }
            >
              <Input.Search
                size="large"
                placeholder="Search by Phone (01...)"
                onSearch={(val) => setMobileNumber(val)}
                enterButton
                loading={driversOptions.loading}
                pattern={`[0-9]`}
                maxLength={11}
              />
            </AutoComplete>
          </Form.Item> */}

          <Form.Item name="range">
            <RangePicker
              onChange={(e, f) => {
                console.log("momnet", moment(f[0])?.toISOString());
                setRange({ from: f?.[0], to: f?.[1] });
              }}
              showTime={{
                hideDisabledOptions: true,
                defaultValue: [
                  moment("00:00:00", "HH:mm:ss"),
                  moment("23:59:59", "HH:mm:ss"),
                ],
              }}
              inputReadOnly
              allowClear
            />
          </Form.Item>
        </Form>

        <div className="search_btn">
          <Button type="primary" danger size="large" onClick={reseAllFieldData}>
            Reset
          </Button>
        </div>
      </section>
      <div className="product-list-item-area white-bg section-padding-bottom">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="product-list-items-inner-content">
                <div className="single-product-wrapper">
                  <div className="single-product-heading">
                    <span>Transaction Id</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Date & Time</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Amount</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Status</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {transactionData?.loading ? (
              <Loading />
            ) : (
              <div className="col-lg-12 product-table">
                <div className="product-table-area">
                  {transactionData?.data?.transactions?.length ? (
                    transactionData?.data?.transactions?.map(
                      (transaction, index) => (
                        <React.Fragment key={index}>
                          <div
                            className="single-product-wrapper"
                            // onClick={() => setSelectedDriver(transaction)}
                          >
                            <div className="single-product">
                              <span className="name">
                                {transaction?.transactionId}
                              </span>
                            </div>
                            <div className="single-product">
                              <span className="name text-capitalize">
                                {moment(transaction?.createdAt).format("lll")}
                              </span>
                            </div>
                            <div className="single-product">
                              <span className="name">
                                &#2547; {transaction?.amount}
                              </span>
                            </div>

                            <div className="single-product">
                              <span
                                className={`radius-btn ${transaction?.type?.toLowerCase()}-btn`}
                              >
                                {transaction?.type?.split("-").join(" ")}
                              </span>
                            </div>
                          </div>
                        </React.Fragment>
                      )
                    )
                  ) : (
                    <Empty data="Data" />
                  )}
                </div>
              </div>
            )}
          </div>

          {/* <Drawer
            title={
              selecteDriverForEdit
                ? "Edit Delivery Hero"
                : "Delivery Hero Details"
            }
            width={selecteDriverForEdit ? 600 : 800}
            onClose={onClose}
            visible={selectedDriver || selecteDriverForEdit}
            bodyStyle={{ paddingBottom: 80 }}
            footer={
              <div
                style={{
                  textAlign: "right",
                }}
              ></div>
            }
          >
            {
              selecteDriverForEdit ? (
                <AddDriver
                  visibleData={selecteDriverForEdit}
                  onCloseMethod={onClose}
                />
              ) : undefined
              // (
              //   <DriverDetails
              //     driverDetails={selectedDriver}
              //     onCloseMethod={onClose}
              //     refetch
              //   />
              // )
            }
          </Drawer> */}

          <PaginationTwo
            {...transactionData?.data}
            limit={limit}
            page={getPage(loc.search)}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default UserTransactionList;
